import { useTranslation } from 'react-i18next'
import {
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { formatHSCode } from 'utils/helpers'

const TnvedProductsTable = ({
  entries,
  readOnly,
  saving,
  onEdit,
  managerView = false,
}: ApplicationTnvedProductsTableProps) => {
  const { t } = useTranslation()
  const cellSx = managerView ? {
    padding: '4px 12px',
  } : undefined

  return (
    <TableContainer component={Paper} variant='outlined' square>
      <Table size='small' aria-label={t('applications__text__tnvedProductsTitle')}>
        <TableHead>
          <TableRow>
            <TableCell sx={cellSx}><Typography variant='inherit' color='inherit'>{t('common__text__products')}</Typography></TableCell>
            <TableCell sx={cellSx}><Typography variant='inherit' color='inherit'>{t('applications__text__tnvedOriginalCode')}</Typography></TableCell>
            <TableCell sx={cellSx}><Typography variant='inherit' color='inherit'>{t('applications__text__tnvedNewCode')}</Typography></TableCell>
            <TableCell sx={cellSx}><Typography variant='inherit' color='inherit'>{t('applications__text__tnvedChangeReason')}</Typography></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry) => {
            const codeChanged = entry.code.trim() !== entry.original_code.trim()

            return (
              <TableRow
                key={entry.product_id}
                sx={{
                  '&:last-child td': {
                    borderBottom: 0,
                  },
                }}
              >
                <TableCell sx={cellSx}><Typography variant='inherit' color='inherit'>{entry.product_name || '—'}</Typography></TableCell>
                <TableCell sx={{
                  ...cellSx,
                  whiteSpace: 'nowrap',
                }}>
                  <Typography variant='inherit' color='inherit'>
                    {formatHSCode(entry.original_code) || '—'}
                  </Typography>
                </TableCell>
                <TableCell sx={{
                  ...cellSx,
                  whiteSpace: 'nowrap',
                }}>
                  <Stack spacing={0.5} alignItems='flex-start' sx={{
                    fontFamily: 'inherit',
                  }}>
                    <Typography variant='inherit' color='inherit' sx={{
                      fontWeight: codeChanged ? 600 : 400,
                    }}>
                      {formatHSCode(entry.code) || '—'}
                    </Typography>
                    {!readOnly && <Link
                      component='button'
                      type='button'
                      variant='body2'
                      underline='hover'
                      disabled={saving}
                      onClick={() => onEdit(entry)}
                    >
                      <Typography component='span' variant='inherit'>
                        {t('applications__text__tnvedChangeCodeButton')}
                      </Typography>
                    </Link>}
                  </Stack>
                </TableCell>
                <TableCell sx={cellSx}>
                  <Typography variant='inherit' color='inherit' sx={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'anywhere',
                  }}>
                    {entry.change_reason?.trim() || '—'}
                  </Typography>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TnvedProductsTable
